import { useRef, useState } from "react";
import { StepNavigation } from "../navigation";
import { DocumentsSection } from "./documents-section";
import { TutorDocumentsType } from "../../../../store/profile/profileSlice";

const TutorBackground = ({ setCurrentStep }) => {
    const educationRef = useRef(null);
    const experienceRef = useRef(null);
    const certificateRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [formError, setFormError] = useState("");

    const onNext = async () => {
        setIsLoading(true);
        setFormError("");
        try {
            const educationOk = await educationRef.current?.flushAndValidate();
            if (!educationOk) {
                setFormError("Please finish the Education section.");
                return;
            }
            const experienceOk = await experienceRef.current?.flushAndValidate();
            if (!experienceOk) {
                setFormError("Please finish the Experience section.");
                return;
            }
            const certificateOk = await certificateRef.current?.flushAndValidate();
            if (!certificateOk) {
                setFormError("Please finish the Certificates section.");
                return;
            }
            setCurrentStep(5);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex flex-col [&_h2]:mb-5 [&_h2]:text-xl [&_h2]:text-nt-blue">
            <h2>Background</h2>
            <p className="text-nt-grey text-sm mb-4">
                Add your education, work experience, and certificates. Save each entry to collapse it, then continue.
            </p>

            {formError ? (
                <p className="text-nt-red text-sm mb-3">{formError}</p>
            ) : null}

            <DocumentsSection
                ref={educationRef}
                type={TutorDocumentsType.education}
                name="education"
                noDocumentField="noEducation"
                checkboxLabel="I don't have an education level"
                title="Education"
                locationLabel="School"
                takeTime
            />

            <DocumentsSection
                ref={experienceRef}
                type={TutorDocumentsType.experience}
                name="experience"
                noDocumentField="noExperience"
                checkboxLabel="I don't have work experience"
                title="Experience"
                locationLabel="Company"
                takeTime
            />

            <DocumentsSection
                ref={certificateRef}
                type={TutorDocumentsType.certificate}
                name="certificates"
                noDocumentField="noCertificate"
                checkboxLabel="I don't have certificates"
                title="Certificates"
                takeTime={false}
            />

            <StepNavigation
                moveBack={() => setCurrentStep(3)}
                moveForward={onNext}
                isLoading={isLoading}
            />
        </div>
    );
};

export { TutorBackground };
